<template>
  <div>
    <d-row style="margin-bottom: 10px;" v-if="photos.length">
      <d-col lg="12">
        <d-alert show>
          <i class="fa fa-info"></i>
          <span>If you click on a photo, it will gray out and will be deleted when you save the changes. If you accidentally clicked on a photo, you can click it again to undo it.</span>
        </d-alert>

        <div class="photos">
          <template v-for="photo in photos">
            <img
              class="photo"

              :src="photo.url"
              :key="`photo-${photo.id}`"
              :class="{ 'is-inactive': !photo.enabled }"

              @click="onPhotoClick($event, photo)"
            />
          </template>
        </div>
      </d-col>
    </d-row>

    <d-row>
      <d-col lg="6">
        <h5>Upload new photos</h5>

        <div class="custom-file" style="margin-bottom: 10px;">
          <input type="file" class="custom-file-input" id="photos" multiple @change="onPhotoUpload" />
          <label class="custom-file-label" for="photos">
            <span v-if="uploadedPhotos.length">{{ uploadedPhotos.length }} photo{{ uploadedPhotos.length === 1 ? '' : 's' }} selected</span>
            <span v-else>Choose file(s)...</span>
          </label>
        </div>

        <d-button theme="primary" :disabled="submitting" @click="onSubmit">Save Changes</d-button>
      </d-col>
    </d-row>
  </div>
</template>

<script>
export default {
  methods: {

    onPhotoClick: function (event, photo) {
      event.preventDefault();

      photo.enabled = !photo.enabled;
    },

    onPhotoUpload: function (event) {
      if (event.target.files.length > 0) {
        this.uploadedPhotos = [];

        Array.prototype.forEach.call(event.target.files, file => {
          this.uploadedPhotos.push({
            fileName: file.name,
            file: file,
          });
        });
      }
    },

    onSubmit: async function (event) {
      event.preventDefault();

      // Assemble the photos.
      const photos = [];

      this.photos.forEach(photo => {
        if (!photo.enabled) {
          return;
        }

        photos.push({
          id: photo.id,
        });
      });

      this.uploadedPhotos.forEach(photo => {
        photos.push({
          file: photo.file,
        });
      });

      this.submitting = true;

      const data = await this.$apollo.mutate({
        mutation: require('~/graphql/parkings/UpdatePhotos.gql'),
        variables: {
          id: this.parking.id,
          photos: photos,
        }
      });

      this.submitting = false;

      if (data.data.updateProvider.provider) {
        window.location.reload(true);
      }
    },

    isDirty: () => false,
  },

  props: {
    parking: {
      required: true,
      type: Object,
    },
  },

  mounted: function () {
    this.photos = this.parking.photos.map(photo => {
      return {
        enabled: true,
        ...photo,
      };
    });
  },

  data: function () {
    return {
      uploadedPhotos: [],
      submitting: false,
      photos: [],
    };
  },
};
</script>

<style lang="scss">
.photos {
  display: flex;
  margin: -5px;
  flex-wrap: wrap;
  align-items: flex-start;
}

.photo {
  width: calc(25% - 5px * 2);
  margin: 5px;
  cursor: pointer;
  transition: opacity ease-in-out .15s, filter ease-in-out .15s;

  &.is-inactive {
    opacity: .5;
    filter: grayscale(100%);
  }
}
</style>
